module.exports = __webpack_public_path__ + "static/media/up_down.e6fddbde.png";